import { render, staticRenderFns } from "./MarketplacesCategories.vue?vue&type=template&id=392e3286&"
import script from "./MarketplacesCategories.vue?vue&type=script&lang=js&"
export * from "./MarketplacesCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports